import styled, {css} from 'styled-components';
import {DEVICE} from '@chekin/guestapp-ui-kit';
import {getBackgroundColor} from 'styled/common';

type WrapperProps = {
  disabled?: boolean;
};

type StyledInputProps = {
  $invalid?: boolean;
  disabled?: boolean;
  $isEmpty?: boolean;
  $isFocused?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  width: 288px;
  min-height: 44px;

  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `};

  @media (max-width: ${DEVICE.mobileS}) {
    width: 293px;
  }
`;

export const WrapperInput = styled.div<WrapperProps>`
  min-height: 44px;
  display: flex;
  flex-direction: column;
  position: relative;

  ${({disabled}) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `}
`;

export const RelativeWrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled.input<StyledInputProps>`
  width: 100%;
  outline: none;
  margin: 0;
  font-size: ${props => props.theme.fonts.sizes.medium};
  transition: background-color 0.25s ease-in-out;
  padding: 13px 16px 13px 9px;
  box-sizing: border-box;
  border-radius: 7px;
  border: none;
  text-overflow: ellipsis;
  height: 48px;
  font-family: inherit;
  font-weight: ${props => props.theme.fonts.fontWeight.regular};
  line-height: 24px;
  color: ${props => props.theme.colors.branding.fontPrimary};
  background-color: ${({$isEmpty, $isFocused}) =>
    getBackgroundColor($isEmpty, $isFocused)};

  &::placeholder {
    font-weight: ${props => props.theme.fonts.fontWeight.regular};
    color: ${props => props.theme.colors.branding.fontPrimary};
    opacity: 1;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 1000px white inset !important;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
    -moz-appearance: textfield;
  }
`;
